import { Controller, type FieldPath, type FieldValues, useFormContext } from 'react-hook-form';
import RadioGroupInput, { type RadioGroupInputProps } from '../../../Form/RadioGroup';
import type { HookInputBaseProps } from '../../types';

export interface HookRadioGroupProps<T extends FieldValues = FieldValues>
  extends Omit<RadioGroupInputProps, 'onChange' | 'value'>,
    HookInputBaseProps<T> {
  name: FieldPath<T>;
  id?: string;
}
export const HookRadioGroup = <T extends FieldValues>(props: HookRadioGroupProps<T>) => {
  const { name, required, validate, id, formMethods, ...rest } = props;
  const { control, setValue, trigger } = useFormContext<T>();
  const idOrName = id || name;
  return (
    <Controller
      name={name}
      rules={{ required: required && 'Required', validate }}
      control={formMethods?.control || control}
      render={({ field, fieldState: { error, isTouched } }) => (
        <>
          <RadioGroupInput
            {...rest}
            {...field}
            id={idOrName}
            onChange={(value) => {
              setValue(name, value);
              trigger(name);
            }}
            error={error?.message}
          />
        </>
      )}
    />
  );
};
